import * as Yup from 'yup';
import { formatInputDate } from '../../../utils/form';
import { TemplateFieldConfig, TemplateFieldsFormValues } from '../../types';

export function parseNumber(value: string) {
  if (!value) return undefined;

  const parsedValue = parseFloat(value);
  return Number.isNaN(parsedValue) ? undefined : parsedValue;
}

export function toDateInputValue(value: unknown) {
  if (!value) return undefined;

  if (value instanceof Date || typeof value === 'number') {
    return formatInputDate(value);
  }

  if (typeof value === 'string') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : formatInputDate(date);
  }

  return undefined;
}

export function toFormFieldValue(value: unknown) {
  if (value === null || value === undefined) return undefined;

  if (typeof value === 'number') {
    return value.toString();
  }

  return value;
}

export function getTimerangeValues(value: unknown) {
  if (typeof value !== 'string') return {};

  const [start, end] = value.split(' - ');

  return {
    start,
    end,
  };
}

export function buildTemplateFieldsValidationSchema(fields: TemplateFieldConfig[]) {
  const shape = fields.reduce<Record<string, Yup.AnySchema>>((result, field) => {
    if (field.validation) {
      result[field.name] = field.validation;
    }

    return result;
  }, {});

  return Yup.object().shape(shape);
}

export const buildTemplateFieldsInitialValues = (
  fields: TemplateFieldConfig[],
  initialValues: TemplateFieldsFormValues,
): TemplateFieldsFormValues => fields.reduce((acc, config) => {
  switch (config.inputType) {
    case 'timerange-picker':
      acc[`${config.name}Start`] = initialValues[`${config.name}Start`] ?? '';
      acc[`${config.name}End`] = initialValues[`${config.name}End`] ?? '';
      break;

    case 'time-unit-input':
      acc[config.name] = initialValues[config.name] ?? '';
      acc[`${config.name}Unit`] = initialValues[`${config.name}Unit`] ?? '';
      break;

    default:
      acc[config.name] = initialValues[config.name] ?? '';
  }
  return acc;
}, {} as TemplateFieldsFormValues);
